export default "__VITE_ASSET__sEembRVm__"